<div class="inbox-lista" [class.inbox-lista--panel]="modo() === 'panel'">
  <!-- ─── Barra de filtros ─────────────────────────────────────────────────── -->
  <div class="inbox-toolbar mb-3">
    <div class="inbox-toolbar__filters">
      @if (modo() === 'pagina') {
        <p-select
          [options]="estadoOptions"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="estado"
          (onChange)="onFiltroChange()"
          styleClass="inbox-select"
          aria-label="Estado de las conversaciones"
        ></p-select>
      }

      <span class="inbox-search">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          placeholder="Buscar por nombre o teléfono…"
          [ngModel]="busqueda"
          (ngModelChange)="onBusquedaChange($event)"
          aria-label="Buscar conversaciones"
        />
      </span>

      <label class="inbox-toggle">
        <p-toggleswitch [(ngModel)]="soloNoLeidos" (onChange)="onFiltroChange()"></p-toggleswitch>
        <span>Solo no leídos</span>
      </label>

      <label class="inbox-toggle" pTooltip="Solo conversaciones de mis campañas. Apágalo para supervisar todas." tooltipPosition="top">
        <p-toggleswitch [(ngModel)]="soloMias" (onChange)="onFiltroChange()"></p-toggleswitch>
        <span>Solo mías</span>
      </label>

      @if (modo() === 'pagina') {
        <label class="inbox-toggle">
          <p-toggleswitch
            [ngModel]="soloCampanas()"
            (ngModelChange)="soloCampanas.set($event)"
          ></p-toggleswitch>
          <span>Solo campañas</span>
        </label>
      }
    </div>

    <div class="inbox-toolbar__meta">
      @if (totalNoLeidos() > 0) {
        <span class="inbox-unread-total" pTooltip="Mensajes sin leer en el inbox" tooltipPosition="top">
          {{ totalNoLeidos() }} sin leer
        </span>
      }
      <button
        pButton
        type="button"
        class="p-button-text p-button-sm"
        [disabled]="cargando()"
        (click)="recargar()"
        pTooltip="Actualizar bandeja"
        tooltipPosition="top"
      >
        <i class="pi pi-refresh" [class.pi-spin]="cargando()"></i>
      </button>
    </div>
  </div>

  <!-- ─── Lista de conversaciones ──────────────────────────────────────────── -->
  @if (cargando() && conversaciones().length === 0) {
    <div class="inbox-loading">
      <p-progressSpinner strokeWidth="4" [style]="{ width: '36px', height: '36px' }"></p-progressSpinner>
      <span>Cargando conversaciones…</span>
    </div>
  } @else if (conversaciones().length === 0) {
    <div class="inbox-empty">
      <i class="pi pi-inbox"></i>
      <span>No hay conversaciones con los filtros actuales.</span>
    </div>
    <!-- La página cruda puede quedar vacía tras filtrar y aun así haber más páginas:
         permitir avanzar también desde el estado vacío. -->
    @if (!finLista()) {
      <div class="inbox-footer">
        <button
          pButton
          type="button"
          class="p-button-outlined p-button-sm"
          [disabled]="cargandoMas()"
          (click)="cargarMas()"
        >
          <span>{{ cargandoMas() ? 'Cargando…' : 'Cargar más' }}</span>
        </button>
      </div>
    }
  } @else {
    <div class="inbox-list" role="list">
      @for (item of conversaciones(); track item.conversationId) {
        <div
          class="inbox-row"
          [class.inbox-row--unread]="item.unreadCount > 0"
          role="listitem"
          tabindex="0"
          (click)="abrirChat(item)"
          (keydown.enter)="abrirChat(item)"
        >
          <div class="inbox-row__avatar" aria-hidden="true">{{ inicial(item) }}</div>

          <div class="inbox-row__body">
            <div class="inbox-row__top">
              <span class="inbox-row__name">{{ nombreMostrado(item) }}</span>
              @if (item.contactPhone) {
                <span class="inbox-row__phone">{{ item.contactPhone }}</span>
              }
              <span class="inbox-row__time">{{ horaRelativa(item.lastActivityAt) }}</span>
            </div>

            <div class="inbox-row__preview" [class.inbox-row__preview--saliente]="!item.esEntrante">
              {{ ultimoMensajeDisplay(item) }}
            </div>

            <div class="inbox-row__chips">
              @if (item.campanaId) {
                <span class="inbox-chip inbox-chip--campana">Campaña: {{ item.campanaNombre ?? item.campanaId }}</span>
              }
              @if (item.idRequisicion) {
                <span class="inbox-chip inbox-chip--req">Req. {{ item.idRequisicion }}</span>
              }
              <span class="inbox-chip" [class.inbox-chip--bot-on]="botActivo(item)" [class.inbox-chip--bot-off]="!botActivo(item)">
                Bot {{ botActivo(item) ? 'ON' : 'OFF' }}
              </span>
              @if (item.status === 'resolved') {
                <span class="inbox-chip inbox-chip--resuelta">Resuelta</span>
              }
            </div>
          </div>

          @if (item.unreadCount > 0) {
            <span class="inbox-row__badge" pTooltip="Mensajes sin leer" tooltipPosition="left">{{ item.unreadCount }}</span>
          }
        </div>
      }
    </div>

    <div class="inbox-footer">
      @if (!finLista()) {
        <button
          pButton
          type="button"
          class="p-button-outlined p-button-sm"
          [disabled]="cargandoMas()"
          (click)="cargarMas()"
        >
          <span>{{ cargandoMas() ? 'Cargando…' : 'Cargar más' }}</span>
        </button>
      } @else {
        <span class="inbox-footer__fin">No hay más conversaciones.</span>
      }
    </div>
  }
</div>
